export enum ColumnFilterType {
  TextStartWith = 0,
  TextContains = 5,
  DateRange = 10,
}
